import { VillageListPage } from "@/features/geolocation/page/VillageListPage";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/admin/geolocation/village/")({
  component: VillageListPage,
});
